const it = {
    registry: {
        list: 'Elenco Clienti',
        title: 'Clienti',
        mutateSubtitle: 'Gestione Nominativo',
        registryName: 'Nominativo',
        registryCode: 'Codice',
        address: 'Indirizzo',
        city: 'Città',
        province: 'Provincia',
        zipCode: 'CAP',
        country: 'Nazione',
        email: 'Email',
        fiscalEmail: 'PEC',
        mobile: 'Cellulare',
        vatCode: 'Partita IVA',
        fiscalCode: 'Codice Fiscale',
        billingId: 'Codice SDI',
        selectRegistry: 'Seleziona Nominativo',


        tabName: {
            CLIENT: 'Clienti',
        },


    },
}
export default it
